import React from 'react';
import { ListItemText, Tooltip, Grid } from '@material-ui/core';
import moment from 'moment';
import { subscription, SUBSCRIPTIONTYPES } from '../../../model/subscription';

export const SubscriptionInfo = (props: { subscription: subscription, classes: any}) => {
    //  setSelected: (value: any) => void}
    const { subscription } = props;

    let name = `${subscription.subscriptionName}`;
    // let email = `${reminder.email}`;
    // // if (reminder.notes)
    // let text = `${reminder.notes}`;
    let expiresOn = '';
    let type = '';
    let tooltip = '';
    // let days = 0;
    // console.log("--------------------------------------------------------------------");
    // console.log(reminder.expiresOn);
    // console.log(m.toDateString);
    if (subscription.subscriptionType === SUBSCRIPTIONTYPES.MENSILE.code) { 
        type = `${subscription.monthToBuy > 0 ? subscription.monthToBuy + ' MESI': 'GIORNI EXTRA'}`;
    }
    if (subscription.subscriptionType === SUBSCRIPTIONTYPES.ACCESSI.code) {
        type = `${subscription.accessToBuy > 0 ? subscription.accessToBuy : ''} INGRESSI`;
    }
    if (subscription.subscriptionType === SUBSCRIPTIONTYPES.CORSI.code) {
        type = `CORSO`;
    }
    if (subscription.notes !== "") {
        tooltip = subscription.notes;
    }
    if (subscription.expiresOn) {
        var m = moment(subscription.expiresOn);
        expiresOn = m.toDate().toLocaleDateString();
        // let today = moment();
        // days = m.diff(today, 'days') // 1
        // expiresOn = `${reminder?.expiresOn?.toLocaleDateString()}`;
    }
    
    return <Grid container> 
        <Grid item xs={12} className={props.classes.subscription}>
            <Grid item xs={6}> 
                <Tooltip title={tooltip}>
                    <ListItemText primary={name} primaryTypographyProps={{ noWrap: true, variant: 'body1', style: { display: 'block' } }} />
                </Tooltip>
            </Grid>
            <Grid item xs={4}>
                <ListItemText primary={type} primaryTypographyProps={{ noWrap: true, variant: 'body1', style: { float: 'left', display: 'block' } }} />
            </Grid>
            <Grid item xs={2}>
                <ListItemText primary={expiresOn} secondary={"Attivo fino al"} primaryTypographyProps={{ noWrap: true, variant: 'body1', style: { display: 'block' } }} />
            </Grid>
        </Grid>
    </Grid>
}